import React, { Component } from 'react';
import ReactMapboxGl, { Marker } from 'react-mapbox-gl';
import supercluster from 'supercluster';
import marker from "../../../../asset/images/icon/marker--single.svg";
import markerNormal from "../../../../asset/images/icon/marker--normal.svg";
import markerMany from "../../../../asset/images/icon/marker--many.svg";
import style from './PropertiesOnClusterMap.module.scss';
import history from "../../../../helper/history";
import Popup from "../../../../components/Mapbox/Popup.component";

const Map = ReactMapboxGl({
  accessToken: 'pk.eyJ1IjoibWVocmRhZGcxMSIsImEiOiJja2xjdWRldTMwYXBvMm5uMTcwbGFxbG82In0.DLf8vvkzDG-IyOoxH1eFKw', // replace with your Mapbox token
});

class MyMapComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      clusters: [],
      zoom: 12,
      selectedProperty: null,
    };

    this.mapRef = React.createRef();

    // Initialize supercluster instance
    this.clusterInstance = new supercluster({
      radius: 40,
      maxZoom: 20,
    });
  }

  componentDidMount() {
    if (this.props.data.length) {
      this.loadClusters();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.data !== this.props.data ||
      prevState.zoom !== this.state.zoom
    ) {
      this.loadClusters();
    }
  }

  loadClusters() {
    const { data } = this.props;

    // Load data into supercluster
    this.clusterInstance.load(
      data.map((point) => ({
        type: 'Feature',
        properties: { cluster: false, ...point },
        geometry: {
          type: 'Point',
          coordinates: [point.location.coordinates[0], point.location.coordinates[1]],

        },
      }))
    );

    this.updateClusters();
  }

  updateClusters = () => {
    const map = this.mapRef.current;
    if (map) {
      const bounds = map.getBounds().toArray().flat();
      const clusters = this.clusterInstance.getClusters(bounds, this.state.zoom);
      this.setState({ clusters });
    }
  };

  onMove = () => {
    const map = this.mapRef.current;
    if (map) {
      this.setState({ zoom: map.getZoom() }, this.updateClusters);
    }
    this.selectProperty({});
  };

  onStyleLoad = (map) => {
    this.mapRef.current = map;
    this.updateClusters(); // Ensure clusters are updated when the map is loaded
  };

  selectProperty = (property = null) => {
    this.setState({ selectedProperty: property.properties });
  };

  showDetail() {
    const { selectedProperty } = this.state;
    history.push(`/advanced-search/${selectedProperty.id}${history.location.search}`);
  }

  render() {
    const { centerCoordinator = ['51.394987', '35.711555'] } = this.props;
    const { clusters, zoom, selectedProperty } = this.state;

    return (
      <div style={{position: 'relative', height: '100%'}}>
        <Map
          style="mapbox://styles/mapbox/streets-v11"
          // style="mapbox://styles/mehrdadg11/ckhv6hl4f03ke19ok269d94x2"
          containerStyle={{
            height: '100%',
            width: '100%'
          }}
          onMove={this.onMove}
          onStyleLoad={this.onStyleLoad}
          zoom={[zoom]}
          center={centerCoordinator}
        >
          {
            selectedProperty && Object.keys(selectedProperty).length && (
              <Popup
                property={selectedProperty}
                onClick={() => {
                  this.showDetail()
                }}
                closePopup={() => this.selectProperty()}
              />
            )
          }
          {clusters.map((cluster) => {
            const { cluster: isCluster, point_count } = cluster.properties;
            if (isCluster) {
              return (
                <Marker
                  key={`cluster-${cluster.id}`}
                  coordinates={cluster.geometry.coordinates}
                  onClick={() => {
                    const expansionZoom = Math.min(
                      this.clusterInstance.getClusterExpansionZoom(cluster.id),
                      20
                    );
                    this.mapRef.current.flyTo({
                      center: cluster.geometry.coordinates,
                      zoom: expansionZoom,
                    });
                  }}
                >
                  <div className={`cluster-marker ${style.cluster_marker}`}>
                    <img onClick={() => this.selectProperty(cluster)} src={point_count <= 100 ? markerNormal : markerMany}/>
                    <span>{point_count}</span>
                  </div>
                </Marker>
              );
            }

            return (
              <Marker
                key={`marker-${cluster.properties.id}`}
                coordinates={cluster.geometry.coordinates}
              >
                <img onClick={() => this.selectProperty(cluster)} src={marker}/>
              </Marker>
            );
          })}
        </Map>
      </div>
    )
  }
}

export default MyMapComponent;
